/**
 * Service Worker Registration
 * Registers and manages the service worker lifecycle
 */

import { logError } from './utils.js';

/**
 * Register service worker
 */
export const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) {
    // eslint-disable-next-line no-console
    console.warn('Service workers are not supported in this browser');
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
    });

    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.log('Service Worker registered successfully:', registration.scope);
    }

    // Check for updates
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;

      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // New service worker available, prompt user to refresh
          showUpdateNotification();
        }
      });
    });

    // Check for updates every hour
    setInterval(
      () => {
        registration.update();
      },
      60 * 60 * 1000
    );
  } catch (error) {
    logError(error, { context: 'Service Worker Registration' });
  }
};

/**
 * Show update notification
 */
const showUpdateNotification = () => {
  const notification = document.createElement('div');
  notification.className = 'alert alert-info';
  notification.style.position = 'fixed';
  notification.style.top = '20px';
  notification.style.right = '20px';
  notification.style.zIndex = '10000';
  notification.style.maxWidth = '300px';
  notification.innerHTML = `
    <div>
      <strong>Update Available</strong>
      <p style="margin: 8px 0;">A new version of TallyPhone is available.</p>
      <button id="updateBtn" class="btn btn-primary" style="margin-top: 8px; font-size: 14px; padding: 8px 16px;">
        Update Now
      </button>
    </div>
  `;

  document.body.appendChild(notification);

  const updateBtn = document.getElementById('updateBtn');
  updateBtn.addEventListener('click', () => {
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    });
  });
};

/**
 * Unregister service worker (for development)
 */
export const unregisterServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      await registration.unregister();
      if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.log('Service Worker unregistered');
      }
    }
  } catch (error) {
    logError(error, { context: 'Service Worker Unregistration' });
  }
};
